import React, {Component} from "react"

import { 
  Button,
  GroupBox,
  Window,
  WindowContent,
  WindowHeader,
  Select,
  Monitor,
} from 'react95'

import Draggable from 'react-draggable';
import { t } from './i18n';

class WindowSettings extends Component {
  constructor(props){
    super(props)
    this.state = {
      opacity: 0,
      selectedWallpaper: props.wallpaper || 'particles',
      selectedLang: props.lang || 'fr',
    }
  }
  close() {
    this.props.close()
  }
  componentDidMount () {
    this.props.centerWindows();
    setTimeout(() => {
      this.props.centerWindows();
      this.setState(() => ({opacity: 1}))
    }, 150)
  }
  apply = () => {
    this.props.onChangeWallpaper(this.state.selectedWallpaper)
    this.props.onChangeLang(this.state.selectedLang)
  }
  getPreviewStyle() {
    switch(this.state.selectedWallpaper) {
      case 'teal':
        return { background: '#008080' }
      case 'photo':
        return { 
          background: 'url("https://images.unsplash.com/photo-1624644128945-920c0da6931b?w=400&q=60") center/cover no-repeat',
        }
      case 'particles':
      default:
        return { background: 'linear-gradient(135deg, #0b4e7d 0%, #0a3d5f 100%)' }
    }
  }
  render(){
    const lang = this.props.lang
    const wallpaperOptions = [
      { value: 'particles', label: t('settingsWallpaperParticles', lang) },
      { value: 'teal', label: t('settingsWallpaperTeal', lang) },
      { value: 'photo', label: t('settingsWallpaperPhoto', lang) },
    ]
    const langOptions = [
      { value: 'fr', label: t('settingsLangFr', lang) },
      { value: 'en', label: t('settingsLangEn', lang) },
    ]
    return (
      <Draggable bounds="parent" handle=".draggable-title">
        <Window style={{opacity: this.state.opacity, zIndex: this.props.zIndex}} className='settings-window window center-window' onMouseDownCapture={this.props.onFocus}>
          <WindowHeader className={`window-title${this.props.isFocused ? '' : ' inactive'}`}>
            <div className="float-right">
              <Button onClick={this.close.bind(this)}>
                &times;
              </Button>
            </div>
            <div className="draggable-title">
              <span className="Settings_16x16_4 window-icon"></span> <span> {t('settingsTitle', lang)}</span>
            </div>
          </WindowHeader>
          <WindowContent>
            <div className="flex-horizontal">
              <div className="flex-1">
                <GroupBox label={t('settingsPreview', lang)} className="all-16">
                  <div className="settings-monitor-wrapper">
                    <Monitor backgroundStyles={this.getPreviewStyle()} />
                  </div>
                </GroupBox>
              </div>
              <div className="flex-1">
                <GroupBox label={t('settingsWallpaper', lang)} className="all-16">
                  <Select
                    defaultValue={this.state.selectedWallpaper}
                    options={wallpaperOptions}
                    menuMaxHeight={160}
                    width='100%'
                    onChange={(e) => this.setState({selectedWallpaper: e.value})}
                  />
                </GroupBox>
                <GroupBox label={t('settingsLanguage', lang)} className="all-16">
                  <Select
                    defaultValue={this.state.selectedLang}
                    options={langOptions}
                    menuMaxHeight={160}
                    width='100%'
                    onChange={(e) => this.setState({selectedLang: e.value})}
                  />
                </GroupBox>
              </div>
            </div>
            <p className='align-right top-16'>
              <Button size='lg' className="buttonLg" onClick={this.close.bind(this)}>{t('settingsClose', lang)}</Button>&nbsp;
              <Button size='lg' className="buttonLg" primary onClick={this.apply}>{t('settingsApply', lang)}</Button>
            </p>
          </WindowContent>
        </Window>
      </Draggable>
    )
  }
}
export default WindowSettings;
